export const DS_API_BASE_PATH = '/hcem/ui'

export const ONE_MINUTE_REFRESH_INTERVAL = 60 * 1000

export const OPTIMIZER_RUNS_AND_SCHEDULES_QUERY_KEY = 'optimizerRunsAndSchedules'

export const OPTIMIZER_CONSTRAINTS_QUERY_KEY = 'optimizerConstraints'

export const OPTIMIZER_SETTINGS_QUERY_KEY = 'optimizerSettings'

// Query keys owned by hcem's PlannerQueryClient. These MUST match hcem's key shapes exactly so that
// accepting an optimized plan invalidates the same caches while the optimizer page runs in dual mode.
export const SCHEDULE_QUERY_KEY = 'schedule'
export const ELECTRICITY_QUERY_KEY = 'electricity'
export const STOCK_DEVELOPMENT_QUERY_KEY = 'stockDevelopment'
export const COST_AVOIDANCE_FOR_RANGE_QUERY_KEY = 'costAvoidanceForRange'
export const COST_AVOIDANCE_DAILY_QUERY_KEY = 'costAvoidanceDaily'
export const COST_AVOIDANCE_MONTHLY_QUERY_KEY = 'costAvoidanceMonthly'
export const OPTIMIZED_SCHEDULES_STATS_QUERY_KEY = 'optimizedSchedulesStats'

export const getOptimizerRunsPath = (plantCode: string): string =>
  `${DS_API_BASE_PATH}/v2/optimizer/${plantCode}/runs`

export const getOptimizerRunPath = (plantCode: string, runId: number): string =>
  `${DS_API_BASE_PATH}/v2/optimizer/${plantCode}/runs/${runId}`

export const getAnalyzeProductionPlanPath = (plantCode: string): string =>
  `${DS_API_BASE_PATH}/v2/optimizer/${plantCode}/run-analysis`

export const getAcceptOptimizedPlanPath = (plantCode: string, scheduleId: number): string =>
  `/plants/${plantCode}/schedules/optimized/${scheduleId}`

export const getOptimizedSchedulesPath = (plantCode: string): string =>
  `/plants/${plantCode}/schedules/optimized`

export const getOptimizerConstraintsPath = (plantCode: string): string =>
  `${DS_API_BASE_PATH}/v2/optimizer/${plantCode}/constraints`

export const getOptimizerSettingsPath = (plantCode: string): string =>
  `${DS_API_BASE_PATH}/v2/optimizer/${plantCode}/settings`
